// extracted by mini-css-extract-plugin
module.exports = {"iconWithText":"iconWithText_iconWithText__DMo1O","withBorder":"iconWithText_withBorder__CBJVM"};